import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";

const routes: Routes = [
  { path: "", loadChildren: "./welcome/welcome.module#WelcomePageModule" },
  { path: "tabs", loadChildren: "./pages/tabs/tabs.module#TabsPageModule" },
  { path: "terms", loadChildren: "./terms/terms.module#TermsPageModule" },
  { path: "login", loadChildren: "./login/login.module#LoginPageModule" },
  { path: "reset", loadChildren: "./reset/reset.module#ResetPageModule" },
  {
    path: "verify",
    loadChildren: "./pages/verify/verify.module#VerifyPageModule",
  },
  {
    path: "register",
    loadChildren: "./register/register.module#RegisterPageModule",
  },
  {
    path: "wallet/home",
    loadChildren: "./pages/wallet/home/home.module#HomePageModule",
  },
  {
    path: "wallet/select",
    loadChildren: "./pages/wallet/select/select.module#SelectPageModule",
  },
  {
    path: "wallet/create",
    loadChildren: "./pages/wallet/create/create.module#CreatePageModule",
  },
  {
    path: "wallet/send",
    loadChildren: "./pages/wallet/send/send.module#SendPageModule",
  },
  {
    path: "wallet/receive",
    loadChildren: "./pages/wallet/receive/receive.module#ReceivePageModule",
  },
  {
    path: "exchange/home",
    loadChildren: "./pages/exchange/home/home.module#HomePageModule",
  },
  {
    path: "news/view",
    loadChildren: "./pages/news/view/view.module#ViewPageModule",
  },
  {
    path: "settings/editprofile",
    loadChildren:
      "./pages/settings/editprofile/editprofile.module#EditprofilePageModule",
  },
  {
    path: "settings/changepassword",
    loadChildren:
      "./pages/settings/changepassword/changepassword.module#ChangepasswordPageModule",
  },
  {
    path: "settings/2fa",
    loadChildren:
      "./pages/settings/twofactor/twofactor.module#TwofactorPageModule",
  },
  {
    path: "settings/about",
    loadChildren: "./pages/settings/about/about.module#AboutPageModule",
  },
  {
    path: "settings/share",
    loadChildren: "./pages/settings/share/share.module#SharePageModule",
  },
  {
    path: "settings/security",
    loadChildren:
      "./pages/settings/security/security.module#SecurityPageModule",
  },
  {
    path: "settings/profile",
    loadChildren: "./pages/settings/profile/profile.module#ProfilePageModule",
  },
  {
    path: "settings/admin",
    loadChildren: "./pages/settings/admin/admin.module#AdminPageModule",
  },
  {
    path: "settings/impsbalance",
    loadChildren:
      "./pages/settings/impsbalance/impsbalance.module#ImpsbalancePageModule",
  },
  {
    path: "settings/impslimit",
    loadChildren:
      "./pages/settings/impslimit/impslimit.module#ImpslimitPageModule",
  },
  {
    path: "settings/prime/enter",
    loadChildren: "./pages/settings/prime/enter/enter.module#EnterPageModule",
  },
  {
    path: "settings/prime/v1/home",
    loadChildren: "./pages/settings/prime/v1/home/home.module#HomePageModule",
  },
  {
    path: "settings/prime/v1/wallet",
    loadChildren:
      "./pages/settings/prime/v1/wallet/wallet.module#WalletPageModule",
  },

  {
    path: "settings/prime/v2/home",
    loadChildren: "./pages/settings/prime/v2/home/home.module#HomePageModule",
  },

  {
    path: "settings/prime/v1/send",
    loadChildren: "./pages/settings/prime/v1/send/send.module#SendPageModule",
  },
  {
    path: "settings/prime/v1/receive",
    loadChildren:
      "./pages/settings/prime/v1/receive/receive.module#ReceivePageModule",
  },
  {
    path: "settings/prime/v1/withdraw",
    loadChildren:
      "./pages/settings/prime/v1/withdraw/withdraw.module#WithdrawPageModule",
  },
  {
    path: "settings/prime/v1/stakings",
    loadChildren:
      "./pages/settings/prime/v1/stakings/stakings.module#StakingsPageModule",
  },
  {
    path: "settings/prime/v1/affiliate",
    loadChildren:
      "./pages/settings/prime/v1/affiliate/affiliate.module#AffiliatePageModule",
  },
  {
    path: "settings/prime/v1/kyc",
    loadChildren: "./pages/settings/prime/v1/kyc/kyc.module#KycPageModule",
  },
  {
    path: "walletoptions/rename",
    loadChildren: "./pages/walletoptions/rename/rename.module#RenamePageModule",
  },
  {
    path: "settings/prime/v2/balance",
    loadChildren:
      "./pages/settings/prime/v2/balance/balance.module#BalancePageModule",
  },
  {
    path: "settings/prime/v2/stakings",
    loadChildren:
      "./pages/settings/prime/v2/stakings/stakings.module#StakingsPageModule",
  },
  {
    path: "settings/prime/v2/team",
    loadChildren: "./pages/settings/prime/v2/team/team.module#TeamPageModule",
  },
  {
    path: "settings/prime/v2/income",
    loadChildren:
      "./pages/settings/prime/v2/income/income.module#IncomePageModule",
  },
  {
    path: "settings/prime/v2/withdrawals",
    loadChildren:
      "./pages/settings/prime/v2/withdrawals/withdrawals.module#WithdrawalsPageModule",
  },
  {
    path: "settings/prime/v2/addstaking",
    loadChildren:
      "./pages/settings/prime/v2/addstaking/addstaking.module#AddstakingPageModule",
  },
  {
    path: "settings/prime/v2/addwithdrawal",
    loadChildren:
      "./pages/settings/prime/v2/addwithdrawal/addwithdrawal.module#AddwithdrawalPageModule",
  },
  {
    path: "assets",
    loadChildren: "./pages/assets/assets.module#AssetsPageModule",
  },
  {
    path: "admin/home",
    loadChildren: "./pages/admin/home/home.module#HomePageModule",
  },
  {
    path: "admin/users",
    loadChildren: "./pages/admin/users/users.module#UsersPageModule",
  },
  {
    path: "admin/wallets",
    loadChildren: "./pages/admin/wallets/wallets.module#WalletsPageModule",
  },
  {
    path: "admin/accounts",
    loadChildren: "./pages/admin/accounts/accounts.module#AccountsPageModule",
  },
  {
    path: "admin/editlimit",
    loadChildren:
      "./pages/admin/editlimit/editlimit.module#EditlimitPageModule",
  },
  {
    path: "admin/viewwallet",
    loadChildren:
      "./pages/admin/viewwallet/viewwallet.module#ViewwalletPageModule",
  },
  {
    path: "admin/withdraw",
    loadChildren: "./pages/admin/withdraw/withdraw.module#WithdrawPageModule",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
